export default "__VITE_ASSET__D3DAi1O___"